// MODIFIED: Unified Service - All original methods preserved for backward compatibility
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

const headers = {
  Authorization: `Bearer ${token}`,
  "Content-Type": "application/json",
};

const salaryAdvanceService = {
  // get Active Loan or active request
  hasActiveSalaryAdvanceLoan: async (employeePersonalInformationId) => {
    const res = await axios.get(`${domain}/api/SalaryAdvanceRequest/has-active-loan/${employeePersonalInformationId}`, { headers });
    return res.data;
  },
  // ── SETUP: Financial Approver Hierarchy ─────────────────────────────
  getHierarchyList: async () => {
    const res = await axios.get(`${domain}/api/FinancialApprover/list`, { headers });
    return res.data;
  },
  getPotentialApprovers: async () => {
    const res = await axios.get(`${domain}/api/FinancialApprover/approver-list`, { headers });
    return res.data;
  },
  saveHierarchy: async (payload, existingId = null) => {
    if (existingId) {
      return await axios.put(`${domain}/api/FinancialApprover/${existingId}`, payload, { headers });
    }
    return await axios.post(`${domain}/api/FinancialApprover`, payload, { headers });
  },

  // ── APPROVALS: Salary Advance Requests ──────────────────────────────
  getRequestsForApprover: async (approverId, filters) => {
    const res = await axios.get(`${domain}/api/SalaryAdvanceRequest/list/${approverId}`, {
      params: filters,
      headers
    });
    return res.data;
  },
  approveRequest: async (id, approverId, remarks) => {
    const res = await axios.post(`${domain}/api/SalaryAdvanceRequest/${id}/approve`, { approverId, remarks }, { headers });
    return res.data;
  },
  disapproveRequest: async (id, approverId, remarks) => {
    const res = await axios.post(`${domain}/api/SalaryAdvanceRequest/${id}/disapprove`, { approverId, remarks }, { headers });
    return res.data;
  },
  updateApprovedAmount: async (id, payload) => {
    const res = await axios.put(`${domain}/api/SalaryAdvanceRequest/${id}/update-approved-amount`, payload, { headers });
    return res.data;
  },
  updateSalaryAdvanceType: async (id, payload) => {
    const res = await axios.put(`${domain}/api/SalaryAdvanceRequest/${id}/update-salary-advance-type`, payload, { headers });
    return res.data;
  },

  // ── SAR METHODS (Gate 3) ───────────────────────
  getAllRequests: async () => {
    const res = await axios.get(`${domain}/api/SalaryAdvanceRequest/list`, { headers });
    return res.data;
  },
  getAllLoanRequestByEmployee: async (employeePersonalInformationId) => {
    const res = await axios.get(`${domain}/api/SalaryAdvanceRequest/employe-loan-request-history/${employeePersonalInformationId}`, { headers });
    return res.data;
  },
  submitRequest: async (payload) => {
    return await axios.post(`${domain}/api/SalaryAdvanceRequest`, payload, { headers });
  },
  cancelRequest: async (id) => {
    return await axios.put(`${domain}/api/SalaryAdvanceRequest/${id}/cancel`, {}, { headers });
  },

  // Salary Advance Loans
  previewLoanSchedule: async (payload) => {
    return await axios.post(`${domain}/api/SalaryAdvanceLoan/preview-schedule`, payload, { headers });
  },
  getLoanList: async () => {
    const res = await axios.get(`${domain}/api/SalaryAdvanceLoan/list`, { headers });
    return res.data;
  },
  getLoanSchedule: async (loanId) => {
    const res = await axios.get(`${domain}/api/SalaryAdvanceLoan/${loanId}/schedule`, { headers });
    return res.data;
  },
  createLoan: async (payload) => {
    console.log({payload})
    return await axios.post(`${domain}/api/SalaryAdvanceLoan/create`, payload, { headers });
  },
  updateLoan: async (loanId, payload) => {
    return await axios.put(`${domain}/api/SalaryAdvanceLoan/${loanId}/update`, payload, { headers });
  },
  activateLoan: async (loanId) => {
    return await axios.put(`${domain}/api/SalaryAdvanceLoan/${loanId}/activate`, {}, { headers });
  },
  releaseLoan: async (loanId) => {
    return await axios.put(`${domain}/api/SalaryAdvanceLoan/${loanId}/release`, {}, { headers });
  }
};

export default salaryAdvanceService;